class ReadMore extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'short', 'full']
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    event.preventDefault()

    const isExpanded = this.getAttribute('aria-expanded') === 'true'
    const nextExpanded = isExpanded === false

    this.els.short.element.hidden = nextExpanded === true
    this.els.full.element.hidden = nextExpanded === false
    this.els.short.element.style.display = nextExpanded === true ? 'none' : ''
    this.els.short.element.setAttribute('aria-hidden', String(nextExpanded))
    this.setAttribute('aria-expanded', String(nextExpanded))
    this.els.trigger.element.setAttribute('aria-expanded', String(nextExpanded))
    this.els.trigger.element.textContent = nextExpanded === true
      ? this.dataset.readLess
      : this.dataset.readMore
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore)
}
